var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { adoptedStyle, customElement } from '@mantou/gem/lib/decorators';
import { createCSSSheet, css } from '@mantou/gem/lib/utils';
import { GemLinkElement, GemActiveLinkElement } from '@mantou/gem/elements/base/link';
import { commonHandle } from '../lib/hotkeys';
import { focusStyle } from '../lib/styles';
export * from '@mantou/gem/elements/base/link';
const style = createCSSSheet(css `
  :host {
    color: inherit;
    text-decoration: inherit;
  }
`);
/**
 * @customElement dy-link
 */
let DuoyunLinkElement = class DuoyunLinkElement extends GemLinkElement {
    constructor() {
        super();
        this.addEventListener('keydown', commonHandle);
    }
};
DuoyunLinkElement = __decorate([
    customElement('dy-link'),
    adoptedStyle(style),
    adoptedStyle(focusStyle)
], DuoyunLinkElement);
export { DuoyunLinkElement };
/**
 * @customElement dy-active-link
 */
let DuoyunActiveLinkElement = class DuoyunActiveLinkElement extends GemActiveLinkElement {
    constructor() {
        super();
        this.addEventListener('keydown', commonHandle);
    }
};
DuoyunActiveLinkElement = __decorate([
    customElement('dy-active-link'),
    adoptedStyle(style),
    adoptedStyle(focusStyle)
], DuoyunActiveLinkElement);
export { DuoyunActiveLinkElement };
//# sourceMappingURL=link.js.map